export default function({ state, commit, dispatch }, notifyData) {

    let patientId = notifyData.patient
    delete notifyData.patient

    commit('startSendingNotification')

    return dispatch('post', {
        url: '/provider/' + (state.id ? state.id : notifyData.provider) + '/patient/' + patientId + '/notify',
        data: notifyData
    }, {
        root: true
    })
        .then((response) => {
            console.log('RES', response)
            commit('finishSendingNotification')
            return response
        })
        .catch((error) => {
            commit('finishSendingNotification')
            throw error
        })
}
